function Remark() {
    return <p className="m-4 p-4 md:w-2/3 md:my-8 md:mx-auto border rounded">
        Ce site présente des statistiques sur les sources fournies dans la description de chaque vidéo de la chaîne YouTube d’actualité: <a className="underline" href="https://www.youtube.com/c/HugoD%C3%A9crypte" rel="external nofollow">Hugo Décrypte - Actus du Jour</a>.
        <br />Les données sont mises à jour quotidiennement.
    </p>
}

export default Remark